/*
 * @Date: 2020-07-08 10:22:38
 * @LastEditTime: 2023-08-21 18:23:07
 */

import Request from '@/utils/request'
import { isTest, getJsonFromUrl } from '@/utils/tools'

/*
UBT数据头定义为app.project[.scene.ab.theme]-page[.element]。
中括号中的字段可选，但是要注意，如果需要设置后面的字段，前面的字段也必须保留，统一使用默认值0。例如wk.opu2.0.a，scene是不需要，但是因为ab存在，所以要设置为默认值0。
各个字段说明如下：
"wk.opu02.a.a-home.rec_list_x"
app：站点标识，为了和玄武的保持一致，内置微课H5为wk，蒲公英位pgy，微课APP为wka。
project：项目名，运营活动统一以opu开头，例如opu2。
scene：入口场景值，用来标识用户从哪里进来。
ab：A/B测试标识，统一使用字母表示。
theme：皮肤主题标识。
page：页面标识，最好有明确语义
element：控件标识，最好有明确语义
*/

export interface ReportServerDataType {
  ubt: string
  evt: EventType
  evt_params: { [key: string]: any }
}

export enum EventType {
  'impress' = 'impress',
  'click' = 'click'
}

export const reportServer = {
  reportServerAPI(param: ReportServerDataType[]) {
    if (isTest()) { return }
    return Request.$post(
      `${isTest() ? 'http://106.52.219.91:8846' : 'https://collector.lizhiweike.com'}/api/data_collector/logs`,
      { data: param },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
  }
}

/** 特殊埋点 */
export const reportSetUbt = (element: string) => {
  let ubt: string = `ubt=wk.opu2-home.${element}`
  if (getJsonFromUrl().scene) {
    ubt = `ubt=wk.opu2.${getJsonFromUrl().scene}-home.${element}`
  } else if (getJsonFromUrl().from && getJsonFromUrl().from === 'outside_site') {
    ubt = `ubt=wk.opu2.hijack-home.${element}`
  }
  return ubt
}



// WEBPACK FOOTER //
// ./src/services/Modules/reportServer.ts